import React from "react";
import { ASSET_TYPE_LIST } from "@quest-finance/quest-fe-shared/dist/application/constants/assetTypes";
import { USAGE_TYPE_LABELS } from "@quest-finance/quest-fe-shared/dist/application/constants/usageTypes";
import { SecurityResponse } from "@quest-finance/quest-fe-shared/dist/application/types/SecurityResponse";
import "./SecurityData.scss";

interface AdditionalSecurityRowProps {
  security: SecurityResponse;
  assetIndex: number;
}

const AdditionalSecurityRow: React.FunctionComponent<
  AdditionalSecurityRowProps
> = ({ security, assetIndex }) => {
  const category = ASSET_TYPE_LIST.find(
    (category) => category.value === security.assetTypeCategory
  );
  const assetType = category?.subTypes.find(
    (type) => type.value === security.assetType
  );
  const usageTypeLabel = USAGE_TYPE_LABELS[security.usageType as string] as
    | string
    | undefined;

  const yearMakeModel = [
    security.manufactureYear,
    security.make,
    security.model,
  ]
    .filter(Boolean)
    .join(" ");

  const summary = [
    usageTypeLabel,
    category?.label,
    assetType?.label,
    yearMakeModel,
    security.description,
  ]
    .filter(Boolean)
    .join(" - ");

  return (
    <div
      className="additional-security-row"
      data-testid={`additional-security-row-${assetIndex}`}
    >
      <h6 className="section-header">Security - Asset {assetIndex}</h6>
      <div
        className="additional-security-summary"
        data-testid={`additional-security-summary-${assetIndex}`}
      >
        {summary}
      </div>
    </div>
  );
};

export default AdditionalSecurityRow;
